import { environment } from "src/environments/environment";

export class InternalName {

    private static _fleet = 'devices';

    public static get singular(): string {
        if (environment.prj === 'tidal') {
            return 'device group';
        } else {
            return 'group'
        }
    }

    public static get plural(): string {
        if (environment.prj === 'tidal') {
            return 'device groups';
        } else {
            return 'groups'
        }
    }

    public static get Singular(): string {
        return this.capitalize(InternalName.singular);
    }
    public static get Plural(): string {
        return this.capitalize(InternalName.plural);
    }
    private static capitalize(word: string): string {
        return word.charAt(0).toUpperCase() + word.slice(1);
    }
    public static get fleet(): string {
        return this._fleet;
    }
}

export class Globals {

    public static get TABS() {
        return {
            CHARTS: 'charts', // tidal main chart page
            MAP: 'map', // ati main map page
            FLEET: InternalName.fleet,
            GROUPS: InternalName.plural,
            USERS: 'team',
            ADMIN_USERS: 'users', // how an admin sees users
            ACCOUNT_SETTINGS: 'account-settings',
        };
    }

    public static readonly DB = {
        FLEET: 'fleet',
        GROUPS: 'organizations',
        USERS: 'users',
    }

}
